module.exports = __webpack_public_path__ + "media/images/diy/brighter_upgrade-0e2dadcd4371b70d931ea3c7b7652750.jpg";